export default __webpack_public_path__ + "static/media/baby-31.ce140c92.svg";